module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner_stores/banner_stores_nagoya-605849d026aedba9a1b45a78b5f6b780.jpg";